var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChoose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3290",
    "data-name": "Group 3290",
    transform: "translate(-5729 -2094)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    transform: "translate(5729 2094)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(5757.669 2119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3289",
    "data-name": "Group 3289",
    transform: "translate(1.034 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3284",
    "data-name": "Group 3284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3283",
    "data-name": "Group 3283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M46.553,45.644,36.809,19.659a.6.6,0,0,0-.622-.415.694.694,0,0,0-.691.415L31.418,30.371l-8.5-16.448v-3.11h8.915a.627.627,0,0,0,.484-.207L36.394,6.39a.668.668,0,0,0,0-.968L32.317,1.207A.418.418,0,0,0,31.9,1H22.227a.653.653,0,0,0-.691.691V13.923l-8.362,16.31-2.142-4.976a.664.664,0,0,0-.622-.415.6.6,0,0,0-.622.415L1.08,45.644a.649.649,0,0,0,.069.622c.138.138.346.346.553.346H45.931a.853.853,0,0,0,.553-.276.622.622,0,0,0,.069-.691ZM35.012,5.907,31.625,9.431H22.918V2.382h8.639ZM10.409,27.33l7.671,17.9H2.738Zm9.122,17.9L13.865,31.891l8.362-16.31L37.5,45.229Zm19.558,0-6.773-13.2L36.187,21.8l8.777,23.428Z",
    transform: "translate(-1.034 -1)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3286",
    "data-name": "Group 3286",
    transform: "translate(23.919 2.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3285",
    "data-name": "Group 3285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M37.273,9.106a1.114,1.114,0,0,0,.484.276,1,1,0,0,0,.484-.138l3.939-3.386a.686.686,0,0,0-.9-1.037L37.895,7.655,36.858,6.411a.686.686,0,1,0-1.037.9Z",
    transform: "translate(-35.645 -4.645)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3288",
    "data-name": "Group 3288",
    transform: "translate(23.859 25.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3287",
    "data-name": "Group 3287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M43.673,54.137a.712.712,0,1,0,1.244-.691L36.9,38.933a.712.712,0,0,0-1.244.691Z",
    transform: "translate(-35.559 -38.559)",
    fill: "#fff"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoose2);
export default __webpack_public_path__ + "static/media/choose2.97608357d0c83e73eecfe61eeccb975e.svg";
export { ForwardRef as ReactComponent };